'use client';

import { useState, type ComponentProps } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export const PasswordInput = ({ className, disabled, ...props }: Omit<ComponentProps<typeof Input>, 'type'>) => {
  const [visible, setVisible] = useState(false);

  return <div className="relative">
    <Input {...props} type={visible ? 'text' : 'password'} disabled={disabled} className={cn('pr-11', className)} />
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="absolute inset-y-0 right-0 h-9 w-9 text-muted-foreground"
      disabled={disabled}
      aria-controls={props.id}
      aria-pressed={visible}
      onMouseDown={(event) => { event.preventDefault(); }}
      onClick={() => { setVisible((current) => { return !current; }); }}
    >
      {visible ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}
      <span className="sr-only">{visible ? 'Hide password' : 'Show password'}</span>
    </Button>
  </div>;
};
